import React, { useEffect } from 'react';
import { Header } from './components/layout/Header';
import { CameraPanel } from './components/camera/CameraPanel';
import { ConversationPanel } from './components/conversation/ConversationPanel';
import { useWebSocket } from './hooks/useWebSocket';

function App() {
  const { connect, disconnect } = useWebSocket();
  
  useEffect(() => {
    connect();
    return () => { disconnect(); };
  }, [connect, disconnect]);
  
  return (
    <div className="min-h-screen lg:h-screen flex flex-col overflow-y-auto lg:overflow-hidden" style={{ background: 'var(--bg-primary)' }}>
      {/* Ambient background orbs */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-20"
          style={{ background: 'radial-gradient(circle, #0ea5e9 0%, transparent 70%)', filter: 'blur(60px)' }} />
        <div className="absolute top-1/2 -right-48 w-96 h-96 rounded-full opacity-15"
          style={{ background: 'radial-gradient(circle, #14b8a6 0%, transparent 70%)', filter: 'blur(80px)' }} />
        <div className="absolute -bottom-32 left-1/3 w-80 h-80 rounded-full opacity-10"
          style={{ background: 'radial-gradient(circle, #6366f1 0%, transparent 70%)', filter: 'blur(60px)' }} />
        <div className="bg-dot-grid absolute inset-0 opacity-100" />
      </div>

      <div className="relative z-10 flex-shrink-0">
        <Header />
      </div>

      <main className="relative z-10 flex-1 lg:min-h-0 px-4 pb-4 pt-3">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_420px] xl:grid-cols-[1fr_480px] gap-4 lg:h-full max-w-[1600px] mx-auto">
          <div className="flex flex-col min-h-[520px] lg:min-h-0">
            <CameraPanel />
          </div>
          <div className="flex flex-col min-h-[360px] lg:min-h-0">
            <ConversationPanel />
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
